import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { adminService } from '../../services/admin.service'
import { UserDetailDto } from '@ivy-monorepo/shared'

interface ClearLoginFailedAttemptsModalProps {
  isOpen: boolean
  onClose: () => void
  publicId: string
  updateUser: (userData: UserDetailDto) => void
}

const ClearLoginFailedAttemptsModal = ({
  isOpen,
  onClose,
  publicId,
  updateUser,
}: ClearLoginFailedAttemptsModalProps) => {
  const [reason, setReason] = useState('')
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleClose = () => {
    if (isPending) return
    onClose()
  }

  const handleClear = async () => {
    if (!publicId) return
    const trimmedReason = reason.trim()
    if (!trimmedReason) {
      setError('Reason is required.')
      return
    }

    try {
      setIsPending(true)
      setError(null)
      const updated = await adminService.clearLoginFailedAttempts(publicId, trimmedReason)
      updateUser(updated)
      onClose()
    } catch (err) {
      console.log('Failed to clear login failed attempts', err)
      setError('Failed to clear login failed attempts.')
    } finally {
      setIsPending(false)
    }
  }

  useEffect(() => {
    if (!isOpen) {
      return
    }
    setReason('')
    setError(null)
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="modal-popup confirm-popup"
      overlayClassName="modal-overlay"
      closeTimeoutMS={300}
    >
      <div className="modal-content-wrapper">
        <h2>Clear failed login attempts</h2>
        <form className="modal-body-content">
          <div className="form-group">
            <label>Reason</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              disabled={isPending}
            />
          </div>
        </form>
        {error && (
          <div className="page-error" style={{ margin: 0 }}>
            {error}
          </div>
        )}
        <div className="modal-footer-content">
          <button type="button" className="styled-button" onClick={handleClose} disabled={isPending}>
            Cancel
          </button>
          <button
            type="button"
            className="styled-button"
            onClick={handleClear}
            disabled={isPending || reason.trim().length < 1}
          >
            Clear attempts
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ClearLoginFailedAttemptsModal
